<template>
  <div class="calendar-btn-selector-container">
    <div class="nav-button calendar-item">
      <div class="calendar-btn-top-area"> </div>
      <button class="btn" @click.prevent="moveMonthBack">
        <i class="fal fa-angle-left"></i>
      </button>
    </div>
    <div class="calendar-btn-selector-list">
      <div class="calendar-selector-month-title">{{monthName}}</div>
    </div>
    <div class="nav-button calendar-item">
      <div class="calendar-btn-top-area"> </div>
      <button class="btn" @click.prevent="moveMonthForward">
        <i class="fal fa-angle-right"></i>
      </button>
    </div>
  </div>
</template>


<script>
import moment from 'moment'

export default {
  name: 'CalendarMonthSelector',
  model: {
    event: 'input'
  },
  props: {
    value: Date,
  },
  watch: {
  },
  computed: {
    monthName() {
      return moment(this.$props.value).local().format('MMMM YYYY')
    }
  },
  mounted() {
  },
  methods: {
    moveMonthBack() {
      let updatedMonth = moment(this.$props.value).local().startOf('month').subtract(1, 'month').startOf('month')
      this.$emit('input', updatedMonth.toDate())
    },
    moveMonthForward() {
      let updatedMonth = moment(this.$props.value).local().startOf('month').add(1, 'month').startOf('month')
      this.$emit('input', updatedMonth.toDate())
    },
  }
}
</script>